import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HomeQuotesStyles, RiskContainer } from './styles/HomeResultPage.styles';
import { EstimateContainer } from '../../common/components/redesignComponents/common/Redesign.styles';
import {
  addHouseQuoteToCart,
  houseQuotesGetQuotes,
  houseQuotesSilentGetQuotes,
  removeHouseQuoteFromCart,
} from '../../features/insuranceRequests/insuranceRequestsActions';
import ErrorComponent from '../../common/components/ErrorComponent';
import { confirmAlert, generalAlertError } from '../../common/utils/alerts';
import HouseModal from './components/HouseModal';
import HouseModalButtons from './components/HouseModalButtons';
import { AvvisoAlert } from '../RcQuotes.styles';
import ConversationModal from '../../common/components/redesignComponents/Modal/ConversationModal';
import { V2FontImport } from '../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import HomeSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/HomeSummaryCard';
import QuoteCostSummaryCard from '../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';
import { primaQuoteTypes } from '../../common/constants';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import FailedQuotationsComponent from '../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function HomeResultPage() {
  const { requestToken } = useParams();
  const navigate = useNavigate();
  const {
    loading,
    error,
    insuranceRequest,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    failedQuotes,
    riskQuotations,
    thread,
    est_provvigioni,
  } = useSelector((store) => store.insuranceRequests.house_quotes);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const refresh = () => houseQuotesGetQuotes(requestToken);

  const silentRefresh = () => houseQuotesSilentGetQuotes(requestToken);

  const modifyData = () => {
    navigate('/quote/casa', {
      state: { requestToken },
    });
  };

  const modifyGuarantees = () => {
    navigate('/quote/casa', {
      state: { requestToken, goToGuarantees: true },
    });
  };

  const selectQuotation = (quoteId, closeButton) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addHouseQuoteToCart(quoteId, refresh, modifyData, closeButton));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeHouseQuoteFromCart(quoteId, refresh, modifyData));
  };

  useEffect(() => {
    houseQuotesGetQuotes(requestToken);
  }, [requestToken]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // const handleRequestPurchase = () => {
  //   if (processingQuote === null) {
  //     generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
  //     return;
  //   }

  //   let extraIncendioAmount = 0; // define outside loop

  //   for (let i = 0; i < riskQuotations.length; i++) {
  //     if (riskQuotations[i].quote_type === 'extra_incendio_contenuto') {
  //       extraIncendioAmount = riskQuotations[i].amount;
  //       break; // stop loop once found
  //     }
  //   }

  //   const totalPrice = processingQuote.amount + extraIncendioAmount;

  //   if (totalPrice < 95) {
  //     generalAlertError('Please Select more quotations to proceed', 'Errore');
  //   } else {
  //     navigate(`/quotes/casa/purchase/${requestToken}`);
  //   }
  // };

  const handleRequestPurchase = () => {
    if (!processingQuote) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    const incendioQuote = riskQuotations.extra_incendio_contenuto;
    const incendioAmount = incendioQuote?.find((item) => item.quote_type === 'extra_incendio_contenuto').amount;

    const basePrice = processingQuote.amount + incendioAmount;
    if (processingQuote.company_id === 1001) {
      // Apply 95€ rule only for company 1001
      if (basePrice >= 95) {
        navigate(`/quotes/casa/purchase/${requestToken}`);
        return;
      }

      const otherExtrasTotal = Object.keys(riskQuotations)
        .filter((key) => key !== 'extra_incendio_contenuto')
        .map((key) => riskQuotations[key]
          .filter((q) => q.is_aquista === 1)
          .reduce((sum, q) => sum + q.amount, 0))
        .reduce((total, amt) => total + amt, 0);

      const finalTotal = basePrice + otherExtrasTotal;

      if (finalTotal < 95) {
        generalAlertError('Seleziona piu garanzie per procedere', 'Errore');
        return;
      }

      navigate(`/quotes/casa/purchase/${requestToken}`);
    } else {
      // For all other companies, navigate normally
      navigate(`/quotes/casa/purchase/${requestToken}`);
    }
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    return (quoteInProccessAmount + risksTotalAmount).toFixed(2);
  };

  // useEffect(() => {
  //   if (loading === false && insuranceRequest.is_expired === true && insuranceRequest.request_token === requestToken) {
  //     navigate('/quote/casa', {
  //       state: { requestToken: insuranceRequest.request_token },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [loading, insuranceRequest, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={insuranceRequest?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_house_result"
        />
      )}
      <V2FontImport />
      <HomeQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <HomeSummaryCard
              customer={customer}
              insuranceRequest={insuranceRequest}
              modifyData={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              productId={insuranceRequest?.product_id}
              onModifyGuarantees={() => modifyGuarantees()}
              rcTypeLabel={processingQuote?.product_name}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12 ">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end ">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                    {/* {localStorage.getItem('quoteNewResult') === 'done' && (
                      <div style={{ cursor: 'pointer' }} onClick={() => firePurchaseTour()}>
                        <button className="btn btn-success px-2 py-1">Tutorial</button>
                      </div>
                    )} */}
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => {
                    const currTypes = processingQuote !== null ? insuranceRequest.quotations?.filter((q) => q.company_id === processingQuote.company_id)?.map((el) => el.quote_type) : [];

                    if (processingQuote === null) {
                      return (
                        <React.Fragment key={index}>
                          {quotations && quotations[type.id] && (
                            <HouseModalButtons
                              insuranceRequest={insuranceRequest}
                              processingQuote={processingQuote}
                              type={type}
                              removeItemFromCart={removeItemFromCart}
                              riskQuotations={riskQuotations}
                              quotations={quotations}
                            />
                          )}
                        </React.Fragment>
                      );
                    }

                    if (currTypes.includes(type.id) || type.id === 'res_civile') {
                      return (
                        <React.Fragment key={index}>
                          {quotations && quotations[type.id] && (
                            <HouseModalButtons
                              insuranceRequest={insuranceRequest}
                              processingQuote={processingQuote}
                              type={type}
                              removeItemFromCart={removeItemFromCart}
                              riskQuotations={riskQuotations}
                              quotations={quotations}
                            />
                          )}
                        </React.Fragment>
                      );
                    }

                    // return (
                    //   <React.Fragment key={index}>
                    //     {quotations && quotations[type.id] && (
                    //     <HouseModalButtons
                    //       insuranceRequest={insuranceRequest}
                    //       processingQuote={processingQuote}
                    //       type={type}
                    //       removeItemFromCart={removeItemFromCart}
                    //       riskQuotations={riskQuotations}
                    //     />
                    //     )}
                    //   </React.Fragment>
                    // );

                    return null;
                  })}
                </RiskContainer>

                {quoteTypes.map((type, index) => (
                  <HouseModal
                    insuranceRequest={insuranceRequest}
                    type={type}
                    key={index}
                    addingQuote={addingQuote}
                    processingQuote={processingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                  />
                ))}
              </>
            )}
        </div>

        {failedQuotes !== null && failedQuotes.length > 0 && (
          <FailedQuotationsComponent failedQuotes={failedQuotes} />
        )}
      </HomeQuotesStyles>
    </>
  );
}

export default HomeResultPage;
